// @ts-nocheck

import { sectionRenderer } from "@theme/section-renderer";
import { startViewTransition } from "@theme/utilities";

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.delay_load =
      this.getAttribute("data-load-delay") && this.getAttribute("data-load-delay") === "true"
        ? true
        : false;

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.delay_load) {
      this.init();
    } else {
      document.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}
customElements.define("main-carousel", MainCarousel);

class MainCollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filters_form = this.querySelector("form");
    this.events = [
      {
        el: this,
        event: "input",
        callback: this.inputHandler.bind(this),
      },
    ];
  }
  connectedCallback() {
    this.handleEventListeners("add");
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }
  handleEventListeners(type = "add") {
    for (const evt of this.events) {
      if (type === "add") {
        evt.el.addEventListener(evt.event, evt.callback);
      } else {
        evt.el.removeEventListener(evt.event, evt.callback);
      }
    }
  }
  inputHandler(e) {
    this.applyFilters();
  }
  async applyFilters() {
    this.classList.add("filters-loading");
    const filter_params = this.getFilterParams();
    const fetch_params = new URLSearchParams(filter_params);
    fetch_params.set("section_id", document.querySelector("#ResultsList").dataset.sectionId);

    try {
      const response = await fetch(`${window.location.pathname}?${fetch_params.toString()}`);
      const html = await response.text();
      const parsed_doc = new DOMParser().parseFromString(html, "text/html");
      const new_grid = parsed_doc.querySelector(".main-collection-grid");
      const current_grid = document.querySelector(".main-collection-grid");
      if (new_grid && current_grid) {
        current_grid.replaceWith(new_grid);
        this.updateHistory(filter_params);
      }
    } catch (error) {
      console.error("CollectionFilters: failed to fetch filtered products", error);
    } finally {
      this.classList.remove("filters-loading");
    }
  }
  getFilterParams() {
    const form_params = new URLSearchParams(new FormData(this.filters_form));
    const filter_params = new URLSearchParams();

    for (const [name, value] of form_params) {
      if (String(value).toLowerCase() !== "all") {
        filter_params.append(name, value);
      }
    }

    return filter_params;
  }
  updateHistory(params) {
    const url = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    history.pushState({}, "", url);
  }
}
customElements.define("main-collection-filters", MainCollectionFilters);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".mphus-faq__container").forEach((faq) => {
    faq.addEventListener("click", (e) => {
      const parentEl = e.currentTarget;
      const answerEl = parentEl.querySelector(".faq-answer");

      if (parentEl.classList.contains("q-active")) {
        parentEl.classList.remove("q-active");
        answerEl.style.height = "0px";
      } else {
        parentEl.classList.add("q-active");
        answerEl.style.height = answerEl.scrollHeight + "px";
      }
    });
  });
});

class VideoElement extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.poster = this.querySelector(".video-element__video-img");

    this.playVideo = this.playVideo.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleEnded = this.handleEnded.bind(this);
  }

  connectedCallback() {
    if (!this.video || !this.poster) return;

    this.poster.addEventListener("click", this.playVideo);

    this.video.addEventListener("play", this.handlePlay);
    this.video.addEventListener("pause", this.handlePause);
    this.video.addEventListener("ended", this.handleEnded);
  }

  disconnectedCallback() {
    this.poster?.removeEventListener("click", this.playVideo);

    this.video?.removeEventListener("play", this.handlePlay);
    this.video?.removeEventListener("pause", this.handlePause);
    this.video?.removeEventListener("ended", this.handleEnded);
  }

  playVideo() {
    this.video?.play();
  }

  handlePlay() {
    this.classList.add("is-playing");
  }

  handlePause() {
    this.classList.remove("is-playing");
  }

  handleEnded() {
    this.video.currentTime = 0;
    this.classList.remove("is-playing");
  }
}

customElements.define("video-element", VideoElement);

class UserManuals extends HTMLElement {
  constructor() {
    super();

    this.productMultipleManuals = this.querySelectorAll(".user-manual__multiple");
  }

  connectedCallback() {
    if (!this.productMultipleManuals) return;

    this.productMultipleManuals.forEach((product) => {
      product.addEventListener("click", () => {
        product.classList.add("open-menu");
      });
      const closeBtn = product.querySelector(".close");
      closeBtn?.addEventListener("click", (e) => {
        e.stopPropagation();
        console.log("hello");
        product.classList.remove("open-menu");
      });
    });
  }
}

customElements.define("user-manuals", UserManuals);

class CompatibilityChecker extends HTMLElement {
  constructor() {
    super();

    this.events = [
      {
        el: this,
        event: "change",
        callback: this.changeHandler.bind(this),
      },
      {
        el: this,
        event: "click",
        callback: this.clickHandler.bind(this),
      },
    ];
    this.initialized = false;
    this.listenersAttached = false;
    this.scrollTimeout = null;
  }

  connectedCallback() {
    if (!this.initialized) {
      this.initialize();
    }

    if (this.initialized) {
      this.handleEventListeners();
    }
  }

  disconnectedCallback() {
    this.handleEventListeners("remove");
    window.clearTimeout(this.scrollTimeout);
    this.scrollTimeout = null;
  }

  initialize() {
    this.brandDropdown = this.querySelector('[data-compatibility-field="brand"]');
    this.modelDropdown = this.querySelector('[data-compatibility-field="model"]');
    this.yearDropdown = this.querySelector('[data-compatibility-field="year"]');
    this.checkerContainer = this.querySelector(".car-seat-checker__container");
    this.selectionSummary = this.querySelector(".car-seat-checker__selection-summary");
    this.selectedCarContainer = this.querySelector(".car-seat-checker__selected-car");
    this.resultsWrapper = this.querySelector(".car-seat-checker__results");
    this.seatTabs = [...this.querySelectorAll("[data-seat-tab]")];

    if (
      !this.brandDropdown ||
      !this.modelDropdown ||
      !this.yearDropdown ||
      !this.checkerContainer ||
      !this.selectionSummary ||
      !this.selectedCarContainer
    ) {
      return;
    }

    const config = this.parseConfig();

    this.brands = Array.isArray(config.brands) ? config.brands : [];
    this.labels = config.labels || {};
    this.tooltips = config.tooltips || {};
    this.selectedCar = {
      brand: "",
      model: "",
      year: "",
    };

    this.brands.forEach((brand) => {
      this.brandDropdown.add(new Option(brand.Name, brand.Name));
    });

    this.initialized = true;
  }

  parseConfig() {
    const configElement = this.querySelector("[data-compatibility-config]");

    if (!configElement) return {};

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.error("CompatibilityChecker: invalid configuration.", error);
      return {};
    }
  }

  handleEventListeners(type = "add") {
    if (type === "add" && this.listenersAttached) return;
    if (type === "remove" && !this.listenersAttached) return;

    for (const evt of this.events) {
      if (type === "add") {
        evt.el.addEventListener(evt.event, evt.callback);
      } else {
        evt.el.removeEventListener(evt.event, evt.callback);
      }
    }

    this.listenersAttached = type === "add";
  }

  changeHandler(event) {
    const field = event.target.closest("[data-compatibility-field]");

    if (!field) return;

    if (field.dataset.compatibilityField === "brand") {
      this.handleBrandChange();
    } else if (field.dataset.compatibilityField === "model") {
      this.handleModelChange();
    } else if (field.dataset.compatibilityField === "year") {
      this.handleYearChange();
    }
  }

  clickHandler(event) {
    const resetButton = event.target.closest(".car-seat-checker__reset");

    if (resetButton) {
      this.resetChecker();
      return;
    }

    const seatTab = event.target.closest("[data-seat-tab]");

    if (!seatTab) return;

    this.seatTabs.forEach((tab) => {
      const isSelected = tab === seatTab;

      tab.classList.toggle("car-seat-checker__seat-tab--selected", isSelected);
      tab.setAttribute("aria-pressed", String(isSelected));
    });
  }

  resetDropdown(dropdown, label) {
    dropdown.replaceChildren(new Option(label, "", true, true));
    dropdown.options[0].disabled = true;
  }

  handleBrandChange() {
    const brand = this.brands.find((item) => item.Name === this.brandDropdown.value);
    const models = brand?.Models || [];

    this.selectedCar.brand = this.brandDropdown.value;
    this.selectedCar.model = "";
    this.selectedCar.year = "";
    this.checkerContainer.classList.add("car-seat-checker__container--model");
    this.checkerContainer.classList.remove(
      "car-seat-checker__container--year",
      "car-seat-checker__container--results",
    );
    this.resetDropdown(this.modelDropdown, this.labels.model || "");
    this.resetDropdown(this.yearDropdown, this.labels.year || "");
    this.yearDropdown.disabled = true;

    models.forEach((model) => {
      this.modelDropdown.add(new Option(model.Name, model.Name));
    });

    this.renderSelectionSummary();
  }

  handleModelChange() {
    const brand = this.brands.find((item) => item.Name === this.brandDropdown.value);
    const model = brand?.Models?.find((item) => item.Name === this.modelDropdown.value);
    const years = model?.Years || [];

    this.selectedCar.model = this.modelDropdown.value;
    this.selectedCar.year = "";
    this.checkerContainer.classList.add("car-seat-checker__container--year");
    this.checkerContainer.classList.remove("car-seat-checker__container--results");
    this.resetDropdown(this.yearDropdown, this.labels.year || "");

    years.forEach((year) => {
      this.yearDropdown.add(new Option(year.Name, year.Name));
    });

    this.yearDropdown.disabled = false;
    this.renderSelectionSummary();
  }

  handleYearChange() {
    const brand = this.brands.find((item) => item.Name === this.brandDropdown.value);
    const model = brand?.Models?.find((item) => item.Name === this.modelDropdown.value);
    const yearData = model?.Years?.find((item) => item.Name === this.yearDropdown.value);

    if (!yearData) return;

    this.selectedCar.year = this.yearDropdown.value;
    this.renderSelectionSummary();
    this.checkerContainer.classList.add("car-seat-checker__container--results");
    this.renderSelectedCar();
    this.updateSeat(yearData.Albert || [], "albert");
    this.updateSeat(yearData.Marie || [], "marie");
    this.updateSeat(yearData.Charlie || [], "charlie");

    window.clearTimeout(this.scrollTimeout);
    this.scrollTimeout = window.setTimeout(() => {
      if (!this.resultsWrapper) return;

      const top = this.resultsWrapper.getBoundingClientRect().top + window.scrollY - 120;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }, 500);
  }

  setIcon(seat, index, seatName) {
    const position = this.querySelector(
      '[data-seat="' + seatName + '"][data-position="' + (index + 1) + '"]',
    );

    if (!position) return;

    const isCompatible = seat.slice(0, 1) === "1";
    const tooltipCode = seat.slice(1, 2);
    let iconUrl = "";

    if (isCompatible && tooltipCode === "Z") {
      iconUrl = "https://cdn.shopify.com/s/files/1/0667/0680/0868/files/tick.svg?v=1698368287";
    } else if (isCompatible) {
      iconUrl = "https://cdn.shopify.com/s/files/1/0667/0680/0868/files/exclaim.svg?v=1698368287";
    }

    position.style.backgroundImage = iconUrl ? 'url("' + iconUrl + '")' : "";
  }

  setTooltip(seat, index, seatName) {
    const position = this.querySelector(
      '[data-seat="' + seatName + '"][data-position="' + (index + 1) + '"]',
    );
    const tooltip = position?.querySelector(".car-seat-checker__tooltip");

    if (!tooltip) return;

    const tooltipCode = seat.slice(1, 2);
    const tooltipText = this.tooltips[tooltipCode];

    tooltip.hidden = tooltipCode === "Z" || !tooltipText;
    tooltip.textContent = tooltipText || "";
  }

  updateSeat(seats, seatName) {
    seats.forEach((seat, index) => {
      this.setIcon(seat, index, seatName);
      this.setTooltip(seat, index, seatName);
    });
  }

  renderSelectedCar() {
    const selection = document.createElement("div");
    const title = document.createElement("div");
    const details = document.createElement("div");

    selection.className = "car-seat-checker__selection";
    title.className = "car-seat-checker__selection-title";
    title.textContent = this.labels.carShown || "";
    details.className = "car-seat-checker__selection-details";

    [this.selectedCar.brand, this.selectedCar.model, this.selectedCar.year].forEach(
      (value, index) => {
        const info = document.createElement("div");

        info.className = "car-seat-checker__selection-value";
        info.textContent = value;
        details.append(info);

        if (index < 2) {
          details.append(document.createElement("hr"));
        }
      },
    );

    selection.append(title, details);
    this.selectedCarContainer.replaceChildren(selection);
  }

  renderSelectionSummary() {
    const values = [this.selectedCar.brand, this.selectedCar.model].filter(Boolean);

    this.selectionSummary.replaceChildren();

    values.forEach((value, index) => {
      const separator = document.createElement("span");

      separator.className = "car-seat-checker__selection-separator";
      separator.textContent = ">";
      this.selectionSummary.append(value, " ", separator);

      if (index < values.length - 1) {
        this.selectionSummary.append(" ");
      }
    });

    this.selectionSummary.hidden = values.length === 0;
  }

  resetChecker() {
    window.clearTimeout(this.scrollTimeout);
    this.scrollTimeout = null;
    this.checkerContainer.classList.remove(
      "car-seat-checker__container--model",
      "car-seat-checker__container--year",
      "car-seat-checker__container--results",
    );
    this.brandDropdown.selectedIndex = 0;
    this.selectedCar = { brand: "", model: "", year: "" };
    this.renderSelectionSummary();
  }
}

customElements.define("compatibility-checker", CompatibilityChecker);
